import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AllAppointmentsData } from 'src/app/_models/all-appointments.model';
import { AllAppointmentsapi } from 'src/app/_services/allappointments.service';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppointmentDetailsComponent } from '../components/appointment-details/appointment-details.component';
import { AddProplemModalComponent } from '../components/add-proplem-modal/add-proplem-modal.component';
import { CloseProblemModalComponent } from '../components/close-problem-modal/close-problem-modal.component';
import { ReactiveModalComponent } from '../components/reactive-modal/reactive-modal.component';
import { RefundModalComponent } from '../components/refund-modal/refund-modal.component';
import { id, TableColumn } from '@swimlane/ngx-datatable';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { DatePipe } from '@angular/common';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';

@Component({
  selector: 'app-all-appointments',
  templateUrl: './all-appointments.component.html',
  styleUrls: ['./all-appointments.component.scss'],
})
export class AllAppointmentsComponent implements OnInit {
  pageTitle: string = 'All Appointments';
  allAppointmentsArray: AllAppointmentsData[] = [];
  specialityDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableCheckAll: true,
  };
  statusDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'state',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: false,
    enableCheckAll: true,
  };
  statusList = [
    { id: 1, state: 'Pending' },
    { id: 2, state: 'Finished' },
    { id: 3, state: 'Cancelled' },
    { id: 4, state: 'Not Completed' },
    { id: 5, state: 'History' },
    { id: 0, state: 'All' },
    { id: 7, state: 'Ready To Join' },
    { id: 8, state: 'Active' },
    { id: 9, state: 'Patient No Show'},
    { id: 10, state: 'Doctor No Show'}
  ];
  specialityList = [];
  selectAllSpecialties = false;
  selectAllStatues = false;
  specialtiesIds: string = '0';
  statusIds: string = '0';
  currentDate: Date = new Date();
  maxDate: Date = new Date();
  params = {};
  appointmentsForm: FormGroup;
  isSubmited: boolean = false;
  modalRef: BsModalRef;
  selectedTab: string = 'All';

  currentPage: number = 1;
  pageSize: number = 20;
  totalPages: number;
  totalItems: number;
  exportedAppointments: AllAppointmentsData[] = [];
  columns: TableColumn[];
  messages: ISmartTableMessage = {
    emptyMessage: 'Hmm, There are no appointments 🥳',
    totalMessage: 'total',
    selectedMessage: ''
  }
  @ViewChild('patientNameRef') public patientNameRef: TemplateRef<any>;
  @ViewChild('displayNameRef') public displayNameRef: TemplateRef<any>;
  @ViewChild('actionRef') public actionRef: TemplateRef<any>;

  constructor(
    private _AllAppoint: AllAppointmentsapi,
    private specialityService: AllSpecialitiesApi,
    public toastr: ToastrService,
    private modalService: BsModalService,
    private _formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.currentDate.setFullYear(this.currentDate.getFullYear() - 1);
    this.currentDate.setMonth(this.currentDate.getMonth() + 9);
    this.maxDate.setDate(this.maxDate.getDate() + 7);

    this.params = {
      specialityIds: '0',
      statusIds: '0',
      FromDate: this.currentDate.toISOString(),
      ToDate: this.maxDate.toISOString(),
      currentPage: this.currentPage,
      pageSize: this.pageSize,
    };
  }

  ngOnInit(): void {
    this.appointmentsForm = this._formBuilder.group({
      appointmentSpecialty: [null],
      appointmentDuration: [[this.currentDate, this.maxDate]],
    });

    this.getAllSpecialties();
    this.getAllAppointments(this.params);
  }

  getAllAppointments(params) {
    this._AllAppoint.getAllAppointments(params).subscribe((res) => {
      this.allAppointmentsArray = res?.data.items;

      setTimeout(() => {
        this.columns = [
          { prop: '', name: 'Patient Name', cellTemplate: this.patientNameRef, width: 200 },
          {
            prop: 'doctorName', name: 'Doctor Name', width: 200,
            pipe: { transform: (val) => val?.toUpperCase() }
          },
          {
            prop: 'appointmentTime', name: 'Appointment Time', width: 200,
            pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y, h:mm a") }
          },
          { prop: 'statusId', name: 'Status', pipe: { transform: (val) => this.getStatusName(val) } },
          { prop: '', name: 'Display Name', cellTemplate: this.displayNameRef, width: 200 },
          {
            prop: 'isHavePrescription', name: 'Has prescription', width: 200,
            pipe: { transform: (val) => val ? "🟢 YES" : "🔴 NO" }
          },
          { prop: '', name: 'Appointment Actions', cellTemplate: this.actionRef, width: 200 },
        ];
      }, 0)

      this.currentPage = res?.data?.pagination.currentPage;
      this.totalPages = res?.data?.pagination.totalPages;
      this.totalItems = res?.data?.pagination.totalItems;
    });
  }

  onChangePage(pageDetails: ISmartTablePagination) {
    this.params['pageSize'] = this.pageSize;
    this.currentPage = pageDetails.offset + 1;
    this.params['currentPage'] = this.currentPage;

    this.getAllAppointments(this.params);
  }

  onSearchAppointment(statusId) {
    this.allAppointmentsArray = [];
    this.currentPage = 1;

    this.selectedTab = this.statusList.find((status) => {
      return status.id == parseInt(statusId);
    }).state;

    this.specialtiesIds = this.generateSpecialtiesIds(
      this.appointmentsForm.value.appointmentSpecialty
    );

    this.statusIds = statusId;

    let durationFrom;
    let durationTo;

    if (this.appointmentsForm.value.appointmentDuration) {
      durationFrom =
        this.appointmentsForm.value.appointmentDuration[0].toISOString();
      durationTo =
        this.appointmentsForm.value.appointmentDuration[1].toISOString();
    } else {
      durationFrom = this.currentDate.toISOString;
      durationTo = this.maxDate.toISOString;
    }

    this.params = {
      specialityIds: this.specialtiesIds,
      statusIds: this.statusIds,
      FromDate: durationFrom,
      ToDate: durationTo,
      currentPage: this.currentPage,
      pageSize: this.pageSize,
    };

    this.getAllAppointments(this.params);
  }

  getAllSpecialties() {
    this.specialityService.getAllSpecialties().subscribe((res) => {
      this.specialityList = res.data?.doctorSpecilaities.map((spec) => {
        return {
          id: spec.id,
          item_text: spec.name,
        };
      });
    });
  }

  onSelectAllSpecialties() {
    this.selectAllSpecialties = !this.selectAllSpecialties;
  }

  onSelectAllStatus() {
    this.selectAllStatues = !this.selectAllStatues;
  }

  generateSpecialtiesIds(selectedSpecialities) {
    if (this.selectAllSpecialties) {
      this.specialtiesIds = '0';
    } else if (selectedSpecialities) {
      this.specialtiesIds = selectedSpecialities
        .map((speciality) => {
          return speciality.id;
        })
        .join(',');
    }

    return this.specialtiesIds;
  }

  getStatusName(id) {
    return id ? this.statusList.find((status) => status.id == id)?.state : '';
  }

  ExportTOExcel(): void {
    this.exportedAppointments = [];
    this.params['pageSize'] = this.totalItems;
    this.params['currentPage'] = 1;

    this._AllAppoint.getAllAppointments(this.params).subscribe((res) => {
      res?.data?.items.map((appointment) => {
        this.exportedAppointments.push(appointment);
      });

      const data = [];
      this.exportedAppointments.map((appointment, index) =>
        data.push({
          patientId: appointment.patientId,
          patientName: appointment.patientName,
          profilePicturePatient: appointment.profilePicturePatient,
          doctorName: appointment.doctorName,
          profilePictureDoctor: appointment.profilePictureDoctor,
          appointmentTime: appointment.appointmentTime,
          patientStartTime: appointment.patientStartTime,
          doctorStartTime: appointment.doctorStartTime,
          creationDate: appointment.creationDate,
          appointmentEndTime: appointment.appointmentEndTime,
          endBy: appointment.endBy,
          isAnonymous: appointment.isAnonymous,
          isSe7etak: appointment.isSe7etak,
          hasProblem: appointment.hasProblem,
          isHavePrescription: appointment.isHavePrescription,
          reactive: appointment.reactive,
          refund: appointment.refund,
          comment: appointment.comment,
          doctorGet: appointment.doctorGet,
          displayName: appointment.displayName,
          callDuration: appointment.callDuration,
        })
      );
      const ws = XLSX.utils.json_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(
        wb,
        `Appointments - from -
      ${this.appointmentsForm.value.appointmentDuration[0]}
       - to -
      ${this.appointmentsForm.value.appointmentDuration[1]}
      .xlsx`
      );
    });
  }

  onAppointmentDetails(selectedItem): void {
    let item = selectedItem.selected[0];
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        item,
      },
    };

    this.modalRef = this.modalService.show(
      AppointmentDetailsComponent,
      initialState
    );
  }

  onRefundHandler(event, item) {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-warning',
      initialState: {
        itemId: item.appointmentId,
      },
    };

    this.modalRef = this.modalService.show(RefundModalComponent, initialState);

    this.modalRef.content.event.subscribe((appointmentId) => {
      this.onRefundSubmit(appointmentId);
    });
  }

  onRefundSubmit(appointmentId) {
    this._AllAppoint.refund(appointmentId).subscribe((response) => {
      this.allAppointmentsArray.find(
        (app) => app.appointmentId === appointmentId
      ).refund = true;
      showNotification(
        'success',
        `The appointment has been refunded`,
        this.toastr
      );
      this.modalRef.hide();
    });
  }

  onReactiveHandler(event, item) {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-success',
      initialState: {
        itemId: item.appointmentId,
      },
    };

    this.modalRef = this.modalService.show(
      ReactiveModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((appointmentId) => {
      this.onReactiveSubmit(appointmentId);
    });
  }

  onReactiveSubmit(appointmentId) {
    this._AllAppoint.reactivate(appointmentId).subscribe((response) => {
      this.allAppointmentsArray.find(
        (app) => app.appointmentId === appointmentId
      ).reactive = true;
      showNotification(
        'success',
        `The appointment has been reactivated`,
        this.toastr
      );
      this.modalRef.hide();
    });
  }

  onAddProblem(event, item): void {
    event.stopPropagation();

    if (item.hasProblem) {
      this.handleCloseProblem(item);
    } else {
      this.handleAddProblem(item);
    }
  }

  handleAddProblem(item) {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        item,
      },
    };

    this.modalRef = this.modalService.show(
      AddProplemModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((proplemDescription) => {
      this.onAddProplemSubmit(item, item.appointmentId, proplemDescription);
    });
  }

  onAddProplemSubmit(appointment, appointmentId, proplemDescription) {
    this._AllAppoint
      .addProblem(appointmentId, 'false', '')
      .subscribe((response) => {
        this.allAppointmentsArray.find(
          (app) => app.appointmentId === appointmentId
        ).hasProblem = true;

        showNotification('success', `The problem has been added`, this.toastr);
        this.modalRef.hide();
      });
  }

  handleCloseProblem(item) {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.appointmentId,
      },
    };

    this.modalRef = this.modalService.show(
      CloseProblemModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((appointmentId) => {
      this.onCloseProblemSubmit(item, appointmentId);
    });
  }

  onCloseProblemSubmit(appointment, appointmentId) {
    this._AllAppoint
      .addProblem(appointmentId, 'true', '')
      .subscribe((response) => {
        this.allAppointmentsArray.find(
          (app) => app.appointmentId === appointmentId
        ).hasProblem = false;

        showNotification('success', `The problem has been closed`, this.toastr);
        this.modalRef.hide();
      });
  }
}
